import { addStation, allStations, deleteStation, updateStation } from '@/utils/request'
import vue from '@/main'

const state = {
  stationList: []
}

const mutations = {
  RESET (state) {
    state.stationList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allStations().then(response => {
        state.stationList = response.data
        resolve(state.stationList)
      })
    })
  },
  stationById ({ commit, state }, id) {
    for (const team of state.stationList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, station) {
    return new Promise((resolve) => {
      updateStation(station).then(() => {
        for (const cur of state.stationList) {
          if (cur.id === station.id) {
            Object.assign(cur, station)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addStation(team).then((response) => {
        state.stationList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, station) {
    return new Promise((resolve) => {
      deleteStation(station).then(() => {
        for (const i in state.stationList) {
          if (state.stationList[i].id === station.id) {
            state.stationList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
